import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { SearchOutlined } from "@ant-design/icons";
import { Table } from "antd";
const Listtable = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("https://data.cityofnewyork.us/resource/wz6d-d3jb.json")
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  const columns = [
    {
      title: "Address",
      dataIndex: "address",
      sorter: (a, b) => a.address.localeCompare(b.address),
      render: (text, record) => (
        <div
          type="link"
          onClick={() => navigate(`/corrections_view`)}
          style={{ color: "black", cursor: "pointer" }}
        >
          {record.house_number} {record.street_name}
        </div>
      ),
    },
    {
      title: "Device#",
      dataIndex: "registration_id",
      sorter: (a, b) => a.registration_id - b.registration_id,
      render: (text) => (
        <div
          type="link"
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer" }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Borough",
      dataIndex: "borough",
    },
    {
      title: "Type of Inspection",
      dataIndex: "nta",
    },
    {
      title: "",
      dataIndex: "action",
      render: () => (
        <div
          onClick={() => navigate("/corrections_view")}
          style={{ color: "black", cursor: "pointer", display: "flex" }}
        >
          <SearchOutlined className="icons-documentation1" />
        </div>
      ),
    },
  ];
  return (
    <>
      <div style={{ padding: "20px" }}>
        <Table columns={columns} dataSource={data} size="middle" />
      </div>
    </>
  );
};

export default Listtable;
